import { useQuery } from "@tanstack/react-query";
import { AdPlacementsService } from "@/services/ad-placements.service";
import { adsHttpClient } from "@/utils/ads.http";
import {
  getPlacementChannelOptions,
  getPlacementChannelZones,
  type PlacementChannelOption,
} from "@/utils/placements";

const adPlacementsService = new AdPlacementsService(adsHttpClient);

export const placementChannelZones: Record<string, string[]> = {};

function syncPlacementChannelZones(channels: PlacementChannelOption[]) {
  Object.keys(placementChannelZones).forEach((channelId) => {
    delete placementChannelZones[channelId];
  });

  Object.entries(getPlacementChannelZones(channels)).forEach(
    ([channelId, zoneIds]) => {
      placementChannelZones[channelId] = zoneIds;
    },
  );
}

async function fetchPlacementCatalog(): Promise<PlacementChannelOption[]> {
  const placementsByChannel =
    await adPlacementsService.listActiveGroupedByChannel();

  const channels = getPlacementChannelOptions(placementsByChannel);

  syncPlacementChannelZones(channels);

  return channels;
}

export type { PlacementChannelOption };

export function usePlacementCatalog() {
  return useQuery({
    queryKey: ["placement-catalog"],
    queryFn: fetchPlacementCatalog,
  });
}
